export default {
    apiKey: "AIzaSyDnZXejWNMcBLeHzL-MuS0wW36MtycvDmE",
    authDomain: "swif-d7093.firebaseapp.com",
    databaseURL: "https://swif-d7093.firebaseio.com",
    projectId: "swif-d7093",
    storageBucket: "swif-d7093.appspot.com",
    messagingSenderId: "931520398463",
    appId: "1:931520398463:web:ff027e228e5f3a13e86b4a",
    measurementId: "G-Z2KG574HJ5"
}